export default __webpack_public_path__ + "static/miniHover-1daaa933b9e3d892155943dd050712d6.png";